<nz-tabset [(nzSelectedIndex)]="selectedTabIndex" [nzDestroyInactiveTabPane]="true">
  <nz-tab
    nzTitle="Query Builder"
    (nzClick)="createQuery()"
    *ngIf="appService.isEngagementActive && authService.hasEntitlements(viewQueryBuildTab)"
  >
    <ng-template nz-tab>
      <app-query-builder [queryId]="queryId"></app-query-builder>
    </ng-template>
  </nz-tab>
  <nz-tab nzTitle="Query History" (nzClick)="showHistory()" *ngIf="authService.hasEntitlements(viewQueryHistoryTab)">
    <ng-template nz-tab>
      <app-query-history></app-query-history>
    </ng-template>
  </nz-tab>
  <nz-tab
    nzTitle="Activation Channels"
    (nzClick)="showActivationChannelHistory()"
    *ngIf="authService.hasEntitlements(viewActivationChannelTab)"
  >
    <ng-template nz-tab>
      <app-activation-channel-list></app-activation-channel-list>
    </ng-template>
  </nz-tab>
  <nz-tab
    nzTitle="Audience Export History"
    (nzClick)="showExportAudienceHistory()"
    *ngIf="authService.hasEntitlements(viewAudienceExportHistoryTab)"
  >
    <ng-template nz-tab>
      <app-audience-export-history></app-audience-export-history>
    </ng-template>
  </nz-tab>
</nz-tabset>
